import './SharedQueriesStyle.css';
import * as React from 'react';
import { FC, useState, useEffect } from 'react';
import { UATConstants } from '../Common/Models/UATConstants';
import { debounce } from 'lodash-es';
import {
  DetailsList,
  DetailsListLayoutMode,
  SelectionMode,
  IColumn,
  Selection,
  CheckboxVisibility,
  ISelection,
} from '@fluentui/react/lib/DetailsList';
import { QueryActions } from './QueryActions';
import { connect } from 'react-redux';
import { getUserProfile, getUsers, setTeamFilter, setViews } from '../actions/Actions';
import {
  TextField,
  PrimaryButton,
  Spinner,
  SpinnerSize,
  IconButton,
  FontIcon,
  MessageBar,
  MessageBarButton,
  MessageBarType,
} from '@fluentui/react';
import { PickerComponent } from '../dashboard/PickerComponent';
import moment from 'moment';
import { ErrorMessage } from 'src/App/Components/Common/ErrorMessage';
import { SuccessMessage } from 'src/App/Components/Common/SuccessMessage';

export interface ISharedQueriesState {
  columnsMyQueries: IColumn[];
  searchQueries: ISharedQuery[];
  selectedMyQueryIds: string[];
  searchMyQueries: string;
  showSpinner: boolean;
  msgMyQueries: string;
  msgMyQueriesError: string;
  loadedMax_MyQrs: boolean;
  countMyQrs: number;
}

export interface ISharedQueriesProps {
  itemsAll: ISharedQuery[];
  hasSharedQueries: boolean;
  migrateQueryType: MigrateQueryType;
}
export enum MigrateQueryType {
  SharedQuery,
  MyQuery,
}

export interface ISharedQuery {
  key: string;
  name: string;
  path: string;
  createdDate: string;
  id: string;
  isSharedQuery: boolean;
  isMyQuery: boolean;
}
const MigrateQueries: FC<ISharedQueriesProps> = ({ ...sharedQueriesProps }) => {
  const params = new URL(window.location.href).searchParams;
  const [showSpinner, setshowSpinner] = useState<boolean>(false);
  const [isCompactMode, setIsCompactMode] = useState<boolean>(false);
  const [searchQueries, setsearchQueries] = useState<ISharedQuery[]>([]);
  const [selectedMyQueryIds, setSelectedMyQueryIds] = useState<string[]>([]);
  //let [_selectionMyQueries, setSelectionMyQueries] = useState<Selection>(new Selection());
  const [searchMyQueries, setsearchMyQueries] = useState<string | undefined>('');
  const [msgMyQueries, setMsgMyQueries] = useState<string>('');
  const [msgMyQueriesError, setMsgMyQueriesError] = useState<string>('');
  const [loadedMax_MyQrs, setLoadedMax_MyQrs] = useState<boolean>(false);
  const [countMyQrs, setcountMyQrs] = useState<number>(0);
  const [btnLabel, setBtnLabel] = useState<string>('');
  const [gridCssClassName, setGridCssClassName] = useState<string>('');
  const [selection, setSelection] = useState(
    new Selection({
      onSelectionChanged: () => onActionGridRowSelect(),
    })
  );
  const onActionGridRowSelect = () => {
    const selectedRows = selection.getSelection();
    if (selectedRows && selectedRows.length > 0) {
      const Ids: string[] = [];
      selectedRows.forEach((row: any) => {
        if (row.id) {
          Ids.push(row.id.toString());
        }
      });
      setSelectedMyQueryIds(Ids);
    } else {
      setSelectedMyQueryIds([]);
    }
  };
  const _onColumnMyQueriesClick = (ev: React.MouseEvent<HTMLElement>, column: IColumn): any => {
    const newColumns: IColumn[] = columnsMyQueries.slice();
    const currColumn: IColumn = newColumns.filter((currCol) => column.key === currCol.key)[0];
    newColumns.forEach((newCol: IColumn) => {
      if (newCol === currColumn) {
        currColumn.isSortedDescending = !currColumn.isSortedDescending;
        currColumn.isSorted = true;
      } else {
        newCol.isSorted = false;
        newCol.isSortedDescending = true;
      }
    });
    const newItems = _copyAndSort(
      searchQueries,
      currColumn.fieldName!,
      currColumn.isSortedDescending
    );
    setColumnsMyQueries(newColumns);
    setsearchQueries(newItems);
  };
  const columnsMyQueries_: IColumn[] = [
    {
      key: 'Name',
      name: 'Name',
      fieldName: 'name',
      minWidth: 210,
      maxWidth: 350,
      isRowHeader: true,
      isResizable: true,
      isSorted: false,
      isSortedDescending: false,
      sortAscendingAriaLabel: 'Sorted A to Z',
      sortDescendingAriaLabel: 'Sorted Z to A',
      onColumnClick: _onColumnMyQueriesClick,
      data: 'string',
      onRender: (item: ISharedQuery) => {
        return <span>{item.name}</span>;
      },
      isPadded: true,
    },
    {
      key: 'Path',
      name: 'Path',
      fieldName: 'Query Path',
      minWidth: 70,
      maxWidth: 400,
      isResizable: true,
      onColumnClick: _onColumnMyQueriesClick,
      data: 'string',
      onRender: (item: ISharedQuery) => {
        return <span>{item.path}</span>;
      },
      isPadded: true,
    },
    {
      key: 'CreatedDate',
      name: 'Created Date',
      fieldName: 'Created Date',
      minWidth: 70,
      maxWidth: 400,
      isResizable: true,
      onColumnClick: _onColumnMyQueriesClick,
      data: 'string',
      onRender: (item: ISharedQuery) => {
        return (
          <span>{moment(item.createdDate).format(UATConstants.DefaultDateFormat).toString()}</span>
        );
      },
      isPadded: true,
    },
  ];
  const [columnsMyQueries, setColumnsMyQueries] = useState<IColumn[]>(columnsMyQueries_);
  useEffect(() => {
    if (sharedQueriesProps.migrateQueryType === MigrateQueryType.MyQuery) {
      setBtnLabel('Copy to User Views');
      setGridCssClassName(
        sharedQueriesProps.hasSharedQueries ? 'myQueriesGrid' : 'myQueriesFullGrid'
      );
    } else if (sharedQueriesProps.migrateQueryType === MigrateQueryType.SharedQuery) {
      setBtnLabel('Copy to Shared Views');
      setGridCssClassName('sharedQueriesGrid');
    }
    applyFilterOnMyQueries();
    intervalIdMyQrs = setInterval(addScrollListener_MyQrs, 2000);
  }, []);

  const applyFilterOnMyQueries = () => {
    const searchMyQueriesStr =
      searchMyQueries?.toLowerCase() != undefined ? searchMyQueries?.toLowerCase() : '';
    let AllMyQrs: ISharedQuery[] = [];
    if (searchMyQueriesStr === '') {
      AllMyQrs = sharedQueriesProps.itemsAll;
    } else {
      AllMyQrs = sharedQueriesProps.itemsAll.filter((x) =>
        x.name.toLowerCase().includes(searchMyQueriesStr.toLowerCase())
      );
    }
    const searchQueries = AllMyQrs.slice(0, UATConstants.recordPerScroll);
    setsearchQueries(searchQueries);
    setLoadedMax_MyQrs(false);
    setcountMyQrs(AllMyQrs.length);
  };

  //Scroll even of MyQueries
  const addScrollListener_MyQrs = () => {
    let cssClsName = '';
    if (sharedQueriesProps.migrateQueryType === MigrateQueryType.MyQuery) {
      cssClsName = sharedQueriesProps.hasSharedQueries ? 'myQueriesGrid' : 'myQueriesFullGrid';
    } else if (sharedQueriesProps.migrateQueryType === MigrateQueryType.SharedQuery) {
      cssClsName = 'sharedQueriesGrid';
    }
    const cssClassName = '.' + cssClsName + ' .ms-DetailsList-contentWrapper';
    const element = document.querySelector(cssClassName);
    if (element) {
      element.addEventListener('scroll', (event: any) => {
        handleScroll_MyQrs(event);
      });
      clearInterval(intervalIdMyQrs);
    }
  };
  let intervalIdMyQrs = setInterval(addScrollListener_MyQrs, 1000);
  const handleScroll_MyQrs = (element: any) => {
    if (element) {
      const bottom =
        element.target.offsetHeight + element.target.scrollTop >= element.target.scrollHeight;
      if (bottom) {
        loadGridDataMyQrs();
      }
    }
  };

  const loadGridDataMyQrs = () => {
    setshowSpinner(true);
    let loadedMax_MyQrs_ = loadedMax_MyQrs;
    if (!loadedMax_MyQrs_) {
      const searchMyQueriesStr =
        searchMyQueries?.toLowerCase() != undefined ? searchMyQueries?.toLowerCase() : '';
      let myQrs: ISharedQuery[] = [];
      if (searchMyQueriesStr === '') {
        myQrs = sharedQueriesProps.itemsAll;
      } else {
        myQrs = sharedQueriesProps.itemsAll.filter((x) =>
          x.name.toLowerCase().includes(searchMyQueriesStr.toLowerCase())
        );
      }
      const TotalItemsCount = myQrs.length;
      const CurrentItemsCount = searchQueries.length;
      if (TotalItemsCount > CurrentItemsCount) {
        loadedMax_MyQrs_ = false;
        const newItems = myQrs.slice(
          CurrentItemsCount,
          CurrentItemsCount + UATConstants.recordPerScroll
        );
        const old = searchQueries;
        newItems.forEach((itm: ISharedQuery) => old.push(itm));
        console.log('no of records loaded : ' + old.length);
        if (TotalItemsCount == old.length) {
          loadedMax_MyQrs_ = true;
        }
        setsearchQueries(old);
        setLoadedMax_MyQrs(loadedMax_MyQrs_);
        setcountMyQrs(TotalItemsCount);
      }
    } else {
      console.log('max data already loaded');
    }
    setTimeout(() => setshowSpinner(false), 100);
    //setshowSpinner(false);
  };
  const btnClick_UserView = () => {
    if (selectedMyQueryIds.length! <= parseInt(UATConstants.QueriesMigrationMaxLimit)) {
      setshowSpinner(true);
      if (sharedQueriesProps.migrateQueryType === MigrateQueryType.MyQuery) {
        QueryActions.MigrateUserViews(selectedMyQueryIds, (isSuccess) => {
          showMigrateMsg(isSuccess);
        });
      } else if (sharedQueriesProps.migrateQueryType === MigrateQueryType.SharedQuery) {
        QueryActions.MigrateSharedViews(selectedMyQueryIds, (isSuccess) => {
          showMigrateMsg(isSuccess);
        });
      }
    } else {
      setshowSpinner(false);
      setMsgMyQueries('');
      setMsgMyQueriesError(UATConstants.ErrorMsgMaxLimit);
      setTimeout(() => setMsgMyQueriesError(UATConstants.ErrorMsgMaxLimit), 30000);
    }
  };
  const showMigrateMsg = (isSuccess: boolean) => {
    if (isSuccess) {
      let msg = '';
      if (selectedMyQueryIds.length == 1) {
        msg = ' ' + selectedMyQueryIds.length + ' Query successfully migrated';
      } else {
        msg = ' ' + selectedMyQueryIds.length + ' Queries successfully migrated';
      }
      selection.setAllSelected(false);
      setSelection(selection);
      setshowSpinner(false);
      setMsgMyQueries(msg);
      setMsgMyQueriesError('');
      setSelectedMyQueryIds([]);

      setTimeout(() => setMsgMyQueries(''), 30000);
    } else {
      setshowSpinner(false);
      setMsgMyQueries('');
      setMsgMyQueriesError('Error : failed to migrate');
      setTimeout(() => setMsgMyQueriesError(''), 30000);
    }
  };
  const _handleTextChange_MyQueries = (
    ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    text?: string
  ) => {
    setsearchMyQueries(text);
    _handleDebounce_MyQueries(ev, text);
  };

  const keyPress_MyQueries = (ev: any) => {
    if (ev.which === 13) {
      applyFilterOnMyQueries();
      ev.preventDefault();
    }
  };
  const _handleDebounce_MyQueries = debounce(
    (ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, text?: string) => {
      applyFilterOnMyQueries();
    },
    1000
  );
  return (
    <>
      {showSpinner && (
        <Spinner
          size={SpinnerSize.large}
          label={UATConstants.PlaceholdersAndTitles.Loading}
          ariaLive='assertive'
          className='loading-panel-full'
        />
      )}
      <div className='myQueriesContainer'>
        <div className='gridQryContainer '>
          <div className='contentBarQry'>
            {sharedQueriesProps.migrateQueryType === MigrateQueryType.MyQuery && (
              <div className='flex-item-labelMyQuery'>
                <div className='qryLabel'>My Queries ({countMyQrs})</div>
              </div>
            )}
            {sharedQueriesProps.migrateQueryType === MigrateQueryType.SharedQuery && (
              <div className='flex-item-labelShared'>
                <div className='qryLabel'>Shared Queries ({countMyQrs})</div>
              </div>
            )}
            <div className='leftbox2'>
              <TextField
                title={UATConstants.PlaceholdersAndTitles.FilterByName}
                onKeyDown={keyPress_MyQueries}
                onChange={_handleTextChange_MyQueries}
                value={searchMyQueries}
                placeholder={UATConstants.PlaceholdersAndTitles.FilterByName}
                className='MyQueries-searchBox'
              />
            </div>
            {msgMyQueries.length > 0 && (
              <div className='flex-item-labelCount'>
                <SuccessMessage
                  containerClassName='ms-Grid-col ms-Grid-row'
                  onDismiss={() => setMsgMyQueries('')}>
                  {msgMyQueries}
                </SuccessMessage>
              </div>
            )}
            {msgMyQueriesError.length > 0 && (
              <div className='flex-item-labelCount'>
                <ErrorMessage
                  containerClassName='ms-Grid-col ms-Grid-row'
                  onDismiss={() => setMsgMyQueriesError('')}>
                  {msgMyQueriesError}
                </ErrorMessage>
              </div>
            )}
            <div className='flex-item-labelCount'></div>
            <div className='migrationButtonUserView'>
              <PrimaryButton
                disabled={selectedMyQueryIds.length > 0 ? false : true}
                className={
                  selectedMyQueryIds.length > 0 ? 'btnSize clickable' : 'btnSize clickable disabled'
                }
                onClick={() => {
                  btnClick_UserView();
                }}
                title={btnLabel}>
                {btnLabel}
              </PrimaryButton>
            </div>
          </div>
          <div className={gridCssClassName}>
            <DetailsList
              items={searchQueries}
              compact={isCompactMode}
              checkboxVisibility={1}
              columns={columnsMyQueries}
              selectionMode={SelectionMode.multiple}
              setKey='none'
              layoutMode={DetailsListLayoutMode.justified}
              isHeaderVisible={true}
              selection={selection}
              selectionPreservedOnEmptyClick={true}
            />
          </div>
        </div>
      </div>
    </>
  );
};

function _copyAndSort<T>(items: T[], columnKey: string, isSortedDescending?: boolean): T[] {
  const key = columnKey as keyof T;
  return items
    .slice(0)
    .sort((a: T, b: T) => ((isSortedDescending ? a[key] < b[key] : a[key] > b[key]) ? 1 : -1));
}

const mapStateToProps = (state: any, ownProps: any) => ({
  ...state,
});

const mapDispatchToProps = {
  setUsers: getUsers,
  setTeam: setTeamFilter,
  setViews: setViews,
};
export default connect(mapStateToProps, mapDispatchToProps)(MigrateQueries);
